module.exports = __webpack_public_path__ + "img/icons-double-left.15c5f5c4.png";